//import initGoogleMap from './components/google-maps';
import initLeafletMap from './components/leaflet-maps';
import initSliderCarousels from './components/slider-carousel';
import initVisualBlocks from './components/visual-block';
import initExpandables from './components/expandable';
import {onDomReady, onFullyLoaded} from './helpers';
import initSliderGalleries from './components/slider-gallery';
import initModals from './components/modals';
import initAxiosForms from "./components/axios-forms";
import initTabs from "./components/tabs";
import initAuth from "./components/auth";
import initDatepicker from "./components/datepicker";
import initCookies from "./components/cookies";
import initCart from "./components/cart";
import initMobileMenu from "./components/mobile-menu";
import initAnimations from "./components/animations";
import initSales from "./components/sales";
import initCompanyInfo from "./components/company-info";
import initMiniMenu from "./components/mini-menu";
import initNavigationBarSticky from "./components/navigation-bar";
import initPopups from "./components/popups";
import initClientInfo from "./components/client-info";
import initWorkoutsModal from "./components/workout";
import initPrograms from "./components/programs";
import initInfoPopup from "./components/info-popup";
import initExpandableTextBlocks from "./components/expandable-text";
import initIntlPhone from "./components/intl-phone";

onDomReady(() => {
	initCookies();
	initMobileMenu();
	initSliderCarousels();
	initVisualBlocks();
	initExpandables();
	//initGoogleMap();
	initLeafletMap();
	initSliderGalleries();
	initModals();
	initAxiosForms();
	initTabs();
	initAuth();
	initDatepicker();
	initCart();
	initAnimations();
	initSales();
	initCompanyInfo();
	initClientInfo();
	initMiniMenu();
	initPopups();
	initWorkoutsModal();
	initPrograms();
	initInfoPopup();
	initExpandableTextBlocks();
	initIntlPhone();
});

onFullyLoaded( () => {
	initNavigationBarSticky();
});
